export class ProductLineError extends Error {
    constructor(msg?: string) {
        super(msg);
        this.name = 'ProductLine';
    }
}
